<template>
  <div class="jin-m jin-m-resume-info">
    <div class="jin-resume-info-head">
      <SelectHeadM :is-fix="isFix" :option="option" :title="title" @change="onChange" />
    </div>
    <div class="jin-m-container jin-m-resume-info-con">
      <component :is="template" :ref="template" :info="tem" @delete="drafts.avatar = ''" />
      <div v-if="!$route.path.includes('ListInfo')" class="jin-resume-btn-group">
        <span v-if="!$route.path.includes('Base') && idx || idx === 0" class="jin-m-delete" @click="onDelete">删除</span>
        <el-button :loading="loading" class="jin-resume-save jin-m-button" @click="onSubmit">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import members from '@/utils/user'
import ListInfo from '../components/listM'
import { BaseOn, Edu, Work, Project, Grade, Attach, BaseUp, Resume, AttachUp } from '../components'
import { mapGetters, mapMutations } from 'vuex'
import { resumeApi } from '@/api'

export default {
  components: {
    ListInfo,
    BaseOn,
    Attach,
    Edu,
    Work,
    Project,
    Grade,
    BaseUp,
    Resume,
    AttachUp
  },
  data() {
    return {
      loading: false,
      // 记录修改次数，前2次是接口赋值，大于2次则是手动修改
      fixNum: 0,
      isFix: false,
      tem: {},
      content: '',
      title: '',
      tips: '',
      option: [
        { text: '在线编辑简历', value: 0 },
        { text: '上传简历', value: 1 }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'drafts',
      'currForm',
      'resumeCon',
      'resume'
    ]),
    template() {
      return this.$route.params.template
    },
    idx() {
      return this.$route.query.idx
    },
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    drafts: {
      handler(n) {
        this.init()
      },
      deep: true
    },
    '$route.path': {
      handler(n) {
        this.fixNum = 0
        this.init()
      },
      deep: true
    },
    tem: {
      handler(n, m) {
        this.fixNum++
        this.isFix = this.fixNum > 2
      },
      deep: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations('resume', ['SET_FORM', 'DELETE_FORM']),
    init() {
      if (this.resumeCon.length) {
        const curr = this.resumeCon.find(item => item.template === this.template)
        this.tem = curr || {}
        this.title = this.tem.title
        this.handleDraft()
      }
    },
    async onDelete() {
      this.drafts[this.tem.type].splice(this.idx, 1)
      delete this.drafts.id
      delete this.drafts.uid
      await resumeApi.addDraft(this.drafts)
      this.$router.go(-1)
    },
    handleDraft() {
      const keys = this.drafts ? Object.keys(this.drafts) : {}
      if (this.drafts && !(JSON.stringify(this.drafts) === '{}')) {
        const drafts = JSON.parse(JSON.stringify(this.drafts))
        if (this.tem.type && keys.includes(this.tem.type)) {
          // 编辑数据
          if ((this.idx || this.idx === 0)) {
            this.tem.formList = drafts[this.tem.type][this.idx] ? [drafts[this.tem.type][this.idx]].map(item => {
              // 数据时间格式
              item.date = item.date || [item.start_time, item.end_time]
              return item
            }) : []
          } else {
            // 新增数据
            this.tem.formList = [{}]
          }
        } else {
          this.tem.form = this.drafts
        }
      } else {
        // 除了附件
        if (this.tem.type) {
          this.tem.formList = [{}]
        }
      }
    },
    async onSubmit() {
      // 保存需要登录
      if (this.userInfo && this.userInfo.nick) {
        const template = this.$refs[this.template]
        // 当前form表单的校验
        let vaild = false
        if (this.tem.type) {
          (Number(this.idx) === 0 || this.idx) ? this.SET_FORM({ idx: this.idx, key: this.tem.type, con: this.resumeCon }) : this.SET_FORM({ key: this.tem.type, con: this.resumeCon })
        } else {
          this.SET_FORM(this.resumeCon)
        }

        if (template && template.submitForm) {
          vaild = template.submitForm()
          // 如果是基本信息需要上传头像
          if (this.template === 'BaseOn' && !(this.currForm.avatar || this.drafts.avatar)) return this.Toast('请上传简历头像')

          // 保存附件
        } else if (['Attach', 'AttachUp', 'Resume'].includes(this.tem.template)) {
          vaild = true
          const curr = this.resumeCon.map(item => {
            if (item.template === 'Attach') item.files = this.tem.files
            return item
          })
          this.SET_FORM(curr)
        }
        // 处理时间长度只有一个的情况['xxx']
        let dateTips = ''
        if (this.tem.formList && this.tem.formList[0] && this.tem.formList[0].date) {
          if (!this.tem.formList[0].date[0]) dateTips = '开始时间不能为空'
          if (!this.tem.formList[0].date[1]) dateTips = '结束时间不能为空'
        }
        if (dateTips) return this.Toast(dateTips)
        // 提价保存
        if (vaild) {
          this.loading = true
          await resumeApi.addDraft(this.currForm)
          this.loading = false
          this.Toast('保存成功')
          this.$router.go(-1)
        }
      } else {
        members.showLogin()
      }
    },
    onChange(v) {
      this.value = v
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/components/postHeadM.scss';

.jin {
  &-resume {
    &-info-head {
      height: 43px;
    }

    &-btn-group {
      display: flex;
      align-items: center;

      .jin-m-delete {
        width: 104px;
        height: 40px;
        margin-top: 30px;
        background: #f3f9fe;
        border-radius: 20px;
        margin-right: 9px;
        font-size: 13px;
        font-weight: 500;
        color: #4777f4;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .jin-m-button {
        flex: 1;
      }
    }
  }

  &-m {
    /deep/ .title h3 {
      margin-bottom: 16px;
    }

    /deep/ .delete {
      display: none;
    }

    /deep/ .el-form {
      &-item {
        margin-bottom: 16px;

        &__label {
          font-size: 11px;
          line-height: 18px;
          margin-bottom: 5px;
        }
      }
    }
  }

  &-m-resume-info {
    // display: flex;
    // flex-direction: column;
    height: 100vh;

    &-con {
      padding-bottom: 30px;
    }

    /deep/ .title {
      /* margin-bottom: 16px; */

      h3 {
        font-size: 16px;
        font-weight: 500;
        color: #3d4351;
        line-height: 23px;
      }
    }
  }

  &-m-container {
    // flex: 1;
    // overflow: scroll;
  }
}
</style>
